module.exports = __webpack_public_path__ + "img/23.d7422729.jpg";